import { countryRequest } from '@/common/queries/selections/countryRequest';
import { useQuery } from '@tanstack/react-query';

export const useCountryRequest = (name: string) => {
  const countryQuery = useQuery({
    queryKey: ['country', name],
    queryFn: () => countryRequest(name),
    staleTime: 1000 * 60 * 10,
    gcTime: 1000 * 60 * 30,
    select: (data) => {
      return data?.results?.map((item) => ({
        label: item.name,
        value: item.id,
      }));
    },
  });
  return { countryQuery };
};
